// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"726":"034586e6","853":"d1443f8d","886":"a32f01e5"}[chunkId] + ".js";
};